const ARTICLES = [
  'the', 'a', 'an', 'to',
  'le', 'la', 'les', 'un', 'une', 'des', 'du', 'de', 'l',
  'il', 'lo', 'gli', 'i', 'uno', 'una',
  'der', 'die', 'das', 'ein', 'eine',
  'el', 'los', 'las',
  'bir',
];

const PLACEHOLDERS = [
  'sb', 'sth', 'smb', 'smth', 'smn', 'somebody', 'something', 'oneself',
  'qn', 'qch', 'qqn', 'qqch', 'qc', 'qcn', 'qcs', 'qualcuno', 'qualcosa',
  'jdn', 'jdm', 'jds', 'etw', 'etwas', 'alguien', 'algo',
];

const CJK = /[぀-ヿ㐀-鿿가-힯]/;
const NOT_CJK = /[^぀-ヿ㐀-鿿가-힯]/gu;

const HOMOPHONES = { 她: '他', 它: '他', 地: '的', 得: '的', 作: '做', 再: '在', 後: '后', 裡: '里', 麼: '么' };

const PRONOUNS = '(i|you|he|she|it|we|they|that|there|who|what|this)';

const CONTRACTIONS = [
  [/\bmr\b/g, 'mister'],
  [/\bmrs\b/g, 'missus'],
  [/\bdr\b/g, 'doctor'],
  [/\bi m\b/g, 'i am'],
  [new RegExp(`\\b${PRONOUNS} re\\b`, 'g'), '$1 are'],
  [new RegExp(`\\b${PRONOUNS} s\\b`, 'g'), '$1 is'],
  [new RegExp(`\\b${PRONOUNS} ve\\b`, 'g'), '$1 have'],
  [new RegExp(`\\b${PRONOUNS} ll\\b`, 'g'), '$1 will'],
  [new RegExp(`\\b${PRONOUNS} d\\b`, 'g'), '$1 would'],
  [/\bwon t\b/g, 'will not'],
  [/\bcan t\b/g, 'can not'],
  [/\bcannot\b/g, 'can not'],
  [/\bshan t\b/g, 'shall not'],
  [/\bain t\b/g, 'is not'],
  [/\b(\w+)n t\b/g, '$1 not'],
  [/\blet s\b/g, 'let us'],
  [/\bgonna\b/g, 'going to'],
  [/\bwanna\b/g, 'want to'],
  [/\bgotta\b/g, 'got to'],
  [/\bok\b/g, 'okay'],
];

const NUMBER_WORDS = {
  zero: 0, one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10,
  eleven: 11, twelve: 12, thirteen: 13, fourteen: 14, fifteen: 15, sixteen: 16, seventeen: 17, eighteen: 18,
  nineteen: 19, twenty: 20, thirty: 30, forty: 40, fifty: 50, sixty: 60, seventy: 70, eighty: 80, ninety: 90,
  hundred: 100, thousand: 1000,
  zéro: 0, deux: 2, trois: 3, quatre: 4, cinq: 5, sept: 7, huit: 8, neuf: 9, dix: 10, onze: 11,
  douze: 12, treize: 13, quatorze: 14, quinze: 15, seize: 16, vingt: 20, trente: 30, quarante: 40,
  cinquante: 50, soixante: 60, cent: 100, mille: 1000,
  null: 0, eins: 1, zwei: 2, drei: 3, vier: 4, fünf: 5, sechs: 6, sieben: 7, acht: 8, neun: 9, zehn: 10,
  elf: 11, zwölf: 12, dreizehn: 13, vierzehn: 14, fünfzehn: 15, sechzehn: 16, siebzehn: 17, achtzehn: 18,
  neunzehn: 19, zwanzig: 20, dreißig: 30, vierzig: 40, fünfzig: 50, sechzig: 60, siebzig: 70, achtzig: 80,
  neunzig: 90, hundert: 100, tausend: 1000,
  due: 2, tre: 3, quattro: 4, cinque: 5, sei: 6, sette: 7, otto: 8, nove: 9, dieci: 10, undici: 11,
  dodici: 12, tredici: 13, quattordici: 14, quindici: 15, sedici: 16, diciassette: 17, diciotto: 18,
  diciannove: 19, venti: 20, trenta: 30, quaranta: 40, cinquanta: 50, sessanta: 60, settanta: 70,
  ottanta: 80, novanta: 90, cento: 100,
  cero: 0, dos: 2, cuatro: 4, cinco: 5, seis: 6, siete: 7, ocho: 8, nueve: 9, diez: 10, once: 11, doce: 12,
  trece: 13, catorce: 14, quince: 15, veinte: 20, treinta: 30, cuarenta: 40, cincuenta: 50, cien: 100,
  sıfır: 0, iki: 2, üç: 3, dört: 4, beş: 5, altı: 6, yedi: 7, sekiz: 8, dokuz: 9, on: 10, yirmi: 20,
  otuz: 30, kırk: 40, elli: 50, altmış: 60, yetmiş: 70, seksen: 80, doksan: 90, yüz: 100, bin: 1000,
  нуль: 0, один: 1, одна: 1, два: 2, дві: 2, три: 3, чотири: 4, пять: 5, девять: 9, шість: 6, сім: 7,
  вісім: 8, десять: 10, двадцять: 20, тридцять: 30, сорок: 40, сто: 100, тисяча: 1000,
};

const CJK_DIGITS = { 零: 0, 〇: 0, 一: 1, 二: 2, 两: 2, 三: 3, 四: 4, 五: 5, 六: 6, 七: 7, 八: 8, 九: 9, 十: 10 };

const expandContractions = (phrase) => CONTRACTIONS.reduce((acc, [re, to]) => acc.replace(re, to), phrase);

const numbersToDigits = (phrase) => phrase
  .replace(/(^|\s)(п|дев) ять(?=\s|$)/g, '$1$2ять')
  .split(' ')
  .map((token) => (Object.prototype.hasOwnProperty.call(NUMBER_WORDS, token) ? String(NUMBER_WORDS[token]) : token))
  .join(' ')
  .replace(/\b([2-9]0) ([1-9])\b/g, (m, tens, unit) => String(Number(tens) + Number(unit)))
  .replace(/[零〇一二两三四五六七八九十]/g, (ch) => String(CJK_DIGITS[ch]));

export const normalizeSpeech = (value) => numbersToDigits(expandContractions(String(value || '')
  .normalize('NFC')
  .toLowerCase()
  .replace(/̇/g, '')
  .replace(/[ʼʹʻ՚׳‘’‛′'`´]/g, ' ')
  .replace(/[^\p{L}\p{N}\s]/gu, ' ')
  .replace(/\s+/g, ' ')
  .trim()));

export const foldAccents = (phrase) => phrase
  .replace(/ß/g, 'ss')
  .replace(/æ/g, 'ae')
  .replace(/œ/g, 'oe')
  .replace(/ø/g, 'o')
  .replace(/ł/g, 'l')
  .replace(/ı/g, 'i')
  .normalize('NFD')
  .replace(/\p{M}/gu, '')
  .replace(/[㐀-鿿]/g, (ch) => HOMOPHONES[ch] || ch);

const compact = (phrase) => phrase.replace(/\s+/g, '');

const stripArticle = (phrase) => {
  const tokens = phrase.split(' ');
  if (tokens.length < 2) return phrase;
  if (ARTICLES.includes(tokens[0])) return tokens.slice(1).join(' ');

  return phrase;
};

const stripPlaceholders = (phrase) => phrase
  .split(' ')
  .filter((token) => !PLACEHOLDERS.includes(token))
  .join(' ');

export const expectedVariants = (word) => {
  const raw = String(word || '');
  const variants = new Set();
  const sources = [raw, raw.replace(/\([^)]*\)/g, ' '), raw.replace(/\[[^\]]*\]/g, ' '), raw.replace(/[()[\]]/g, ' ')];
  sources.forEach((candidate) => {
    candidate.split(/\s*(?:[/,;=|]|\s[-–—]\s|[–—])\s*/).forEach((part) => {
      const normalized = normalizeSpeech(part);
      if (!normalized) return;
      [normalized, stripArticle(normalized), stripPlaceholders(normalized), stripArticle(stripPlaceholders(normalized))]
        .forEach((variant) => variant && variants.add(variant));
      if (CJK.test(normalized)) {
        const cjkOnly = normalized.replace(NOT_CJK, '');
        if (cjkOnly) variants.add(cjkOnly);
        variants.add(compact(normalized));
      }
    });
  });

  return [...variants].filter(Boolean);
};

const levenshtein = (a, b) => {
  if (a === b) return 0;
  if (!a.length) return b.length;
  if (!b.length) return a.length;
  let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i += 1) {
    const row = [i];
    for (let j = 1; j <= b.length; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      row[j] = Math.min(prev[j] + 1, row[j - 1] + 1, prev[j - 1] + cost);
    }
    prev = row;
  }

  return prev[b.length];
};

export const similarity = (a, b) => {
  const left = compact(a);
  const right = compact(b);
  const max = Math.max(left.length, right.length);
  if (!max) return 1;

  return 1 - levenshtein(left, right) / max;
};

const containsPhrase = (haystack, needle) => {
  const h = haystack.split(' ');
  const n = needle.split(' ');
  if (!needle || n.length > h.length) return false;
  for (let i = 0; i + n.length <= h.length; i += 1) {
    if (n.every((token, k) => token === h[i + k])) return true;
  }

  return false;
};

const isExact = (heard, variant) => {
  if (heard === variant || compact(heard) === compact(variant)) return true;
  if (CJK.test(variant)) return compact(heard).replace(NOT_CJK, '') === compact(variant).replace(NOT_CJK, '');

  return containsPhrase(heard, variant);
};

export const matchPronunciation = (word, transcripts) => {
  const variants = expectedVariants(word);
  const heard = (transcripts || [])
    .map((raw) => ({ raw: String(raw || '').trim(), transcript: normalizeSpeech(raw) }))
    .filter((entry) => entry.transcript);
  if (!heard.length || !variants.length) return { verdict: 'none', heard: '', score: 0 };

  let best = { verdict: 'wrong', heard: heard[0].raw, score: 0 };
  heard.forEach(({ raw, transcript }) => {
    const folded = foldAccents(transcript);
    variants.forEach((variant) => {
      const foldedVariant = foldAccents(variant);
      const exact = isExact(transcript, variant) || isExact(folded, foldedVariant);
      const score = exact ? 1 : similarity(folded, foldedVariant);
      if (score > best.score) best = { verdict: 'wrong', heard: raw, score };
    });
  });

  if (best.score >= 0.999) best.verdict = 'ok';
  else if (best.score >= (CJK.test(best.heard) ? 0.5 : 0.75)) best.verdict = 'close';

  return best;
};
